/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_A3dInputs */

const en_mk_sol_ukm_a3d = /** @type {(inputs: Mk_Sol_Ukm_A3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepares the weekly promo material and posting schedule, always through an approval before it ships.`)
};

const id_mk_sol_ukm_a3d = /** @type {(inputs: Mk_Sol_Ukm_A3dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menyusun materi promo mingguan dan jadwal unggahan, selalu lewat approval sebelum tayang.`)
};

/**
* | output |
* | --- |
* | "Prepares the weekly promo material and posting schedule, always through an approval before it ships." |
*
* @param {Mk_Sol_Ukm_A3dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_a3d = /** @type {((inputs?: Mk_Sol_Ukm_A3dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_A3dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_a3d(inputs)
	return en_mk_sol_ukm_a3d(inputs)
});